export const AUTH_LOGIN = 'AUTH_LOGIN'
export const AUTH_LOGOUT = 'AUTH_LOGOUT'
export const AUTH_TOKEN = 'AUTH_TOKEN'
export const AUTH_INIT = 'AUTH_INIT'
export const AUTH_USER = 'AUTH_USER'
